// removed by extract-text-webpack-plugin
module.exports = {"root":"Band__root___1nEZ-","title":"Band__title___3RKA4","members":"Band__members___FpWCk"};


//////////////////
// WEBPACK FOOTER
// ./app/views/Band/Band.css
// module id = 104
// module chunks = 0